import { Button } from '@casumo/dojo-react';
import { useState } from 'react';
import { TWelcomeOffer } from '../../cms';
import { TEST_ID } from '../../utils/constants';

type Props = {
  welcomeOffer: TWelcomeOffer;
  handleOnKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  handleSelect: (offerId: string) => void;
};

export const WelcomeOfferCard = ({ welcomeOffer, handleOnKeyDown, handleSelect }: Props) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const isExclusive = welcomeOffer.isExclusive;

  return (
    <div className="md:min-w-[76%] min-w-[64%] snap-center">
      <div
        id={welcomeOffer?.name}
        className="flex flex-col rounded-lg"
        tabIndex={0}
        onKeyDown={handleOnKeyDown}
        data-testid={TEST_ID.PREFIX + 'wo-card-' + welcomeOffer.vertical}
      >
        <div className="relative w-full">
          <div className={ isExclusive ? 'glance-effect' : ''}>
            <img
              onLoad={() => setIsImageLoaded(true)}
              src={welcomeOffer?.thumbnailImage}
              alt={welcomeOffer.vertical}
              className="w-full min-h-[290px] tablet:min-h-auto rounded-lg object-cover"
            />
          </div>
          {isImageLoaded && (
            <div
              className={`flex flex-col justify-between h-full items-center text-center p-md
                       absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full`}
            >
              <div
                className="bg-yellow-20 text-purple-60 text-xs font-bold rounded-lg px-md py-3xs"
                data-testid={TEST_ID.TITLE + 'wo-' + welcomeOffer.vertical}
              >
                {welcomeOffer.title}
              </div>

              <div
                className="font-midnight-st font-extrabold text-[38px] leading-[34px]
                         tablet:leading-[44px] tablet:text-[50px] uppercase text-white"
                data-testid={TEST_ID.DESCRIPTION + 'wo-' + welcomeOffer.vertical}
              >
                {welcomeOffer?.shortDesc}
              </div>
              <div className="min-w-full tablet:min-w-[350px]">
                <Button
                  onClick={() => handleSelect(welcomeOffer.name)}
                  className="bg-purple-60 text-white p-lg w-full mix-w-[350px]"
                  data-testid={TEST_ID.PREFIX + 'wo-button-' + welcomeOffer.vertical}
                >
                  {welcomeOffer?.selectButton || 'Select offer'}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
